import React from 'react';
import { Eye, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './ImpersonationBanner.css';

/**
 * ImpersonationBanner -- persistent banner shown when an admin is viewing
 * the app as another user. Shows who they're viewing as and provides
 * a button to exit back to their admin session.
 *
 * This is read-only mode: the admin can see everything the user sees
 * but cannot perform any write actions (submit requests, edit data, etc.).
 */
function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonating } = useAuth();

  if (!isImpersonating || !user) return null;

  const displayName = user.first_name
    ? `${user.first_name} ${user.last_name || ''}`.trim()
    : user.name || user.email;

  const handleExit = async () => {
    try {
      await stopImpersonating();
      // Force full page reload to reset all component state cleanly
      window.location.href = '/admin/users';
    } catch {
      // If stop fails, force reload anyway to clear stale state
      window.location.href = '/admin/users';
    }
  };

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner-content">
        <Eye size={16} strokeWidth={2} />
        <span>
          Viewing as <strong>{displayName}</strong> ({user.role})
          <span className="impersonation-readonly"> -- Read-only mode</span>
        </span>
      </div>
      <button className="impersonation-exit-btn" onClick={handleExit}>
        <X size={14} />
        Exit
      </button>
    </div>
  );
}

export default ImpersonationBanner;
